import { Button, Cascader, Form, Input, InputNumber, message } from 'antd'
import type { FormProps } from 'antd'
import React, { useCallback, useState } from 'react'

import { patchTextbook, postTextbook } from '~/services/textbook'
import { ITextbook } from '~/types/textbook'
import { ITextbookCategory } from '~/types/textbook-category'

import { ModalFormContainer } from './style'

const Index: React.FC<{
  data: Partial<ITextbook>
  categoryList: ITextbookCategory[]
  refreshTable: () => void
}> = (props) => {
  const { data, categoryList, refreshTable } = props

  const [loading, setLoading] = useState(false)
  const onFinish = useCallback<
    Required<FormProps<Partial<ITextbook>>>['onFinish']
  >(
    (value) => {
      setLoading(true)
      if (!data.id) {
        postTextbook({
          ...data,
          ...value,
          categoryId: value.categoryId
            ? // @ts-expect-error any
              value.categoryId[value.categoryId.length - 1]
            : undefined,
        })
          .then(() => {
            message.success('操作成功')
            refreshTable()
          })
          .catch((err) => {
            message.error(
              err?.response?.data || err?.message || '操作失败，请稍后再试',
            )
          })
          .finally(() => {
            setLoading(false)
          })
      } else {
        patchTextbook(data.id, {
          unit: '',
          chapter: '',
          onlineUrl: '',
          downloadUrl: '',
          author: '',
          tags: '',
          description: '',
          ...value,
          // @ts-expect-error any
          categoryId: value.categoryId[value.categoryId.length - 1],
        })
          .then(() => {
            message.success('操作成功')
            refreshTable()
          })
          .catch((err) => {
            message.error(
              err?.response?.data || err?.message || '操作失败，请稍后再试',
            )
          })
          .finally(() => {
            setLoading(false)
          })
      }
    },
    [data, refreshTable],
  )

  const findCategoryId = useCallback(
    (categoryId?: number) => {
      if (!categoryId) {
        return []
      }
      if (categoryList.find((item) => item.id === categoryId)) {
        return [categoryId]
      }

      for (let i = 0; i < categoryList.length; i++) {
        if (categoryList[i].children?.length > 0) {
          for (let j = 0; j < categoryList[i].children.length; j++) {
            if (categoryId === categoryList[i].children[j].id) {
              return [categoryList[i].id, categoryList[i].children[j].id]
            }
          }
        }
      }
    },
    [categoryList],
  )

  return (
    <ModalFormContainer>
      <Form
        name="text-book-edit"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        autoComplete="off"
        initialValues={{
          ...data,
          categoryId: findCategoryId(data.categoryId),
        }}
        onFinish={onFinish}
      >
        <Form.Item
          label={
            data.level === 1 ? '教材名' : data.level === 2 ? '单元名' : '章节名'
          }
          name="title"
          rules={[{ required: true, message: '请输入教材名' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="教材分类" name="categoryId">
          <Cascader
            style={{ width: 200, marginLeft: 8 }}
            options={categoryList}
            fieldNames={{ value: 'id', label: 'name' }}
            changeOnSelect
            disabled={data.level !== 1}
          />
        </Form.Item>
        <Form.Item label="parentId" name="parentId">
          <InputNumber disabled />
        </Form.Item>
        <Form.Item label="层级" name="level">
          <InputNumber disabled />
        </Form.Item>
        {data.level === 1 && (
          <>
            <Form.Item label="作者" name="author">
              <Input />
            </Form.Item>
            <Form.Item label="标签" name="tags">
              <Input />
            </Form.Item>
            <Form.Item label="简介" name="description">
              <Input />
            </Form.Item>
          </>
        )}
        {(data.level === 2 || data.level === 3) && (
          <Form.Item label="单元" name="unit">
            <Input disabled={data.level === 3} />
          </Form.Item>
        )}
        {data.level === 3 && (
          <Form.Item label="章节" name="chapter">
            <Input />
          </Form.Item>
        )}
        <Form.Item label="预览链接" name="previewUrl">
          <Input />
        </Form.Item>
        {data.level === 3 && (
          <Form.Item label="下载链接" name="downloadUrl">
            <Input />
          </Form.Item>
        )}
        <Form.Item label="排序" name="order">
          <InputNumber />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button loading={loading} type="primary" htmlType="submit">
            提交
          </Button>
        </Form.Item>
      </Form>
    </ModalFormContainer>
  )
}

export default Index
